export default codegenNativeComponent<NativeProps>('Test');
